import { render, staticRenderFns } from "./ColumnTefError.vue?vue&type=template&id=3ecb750f&scoped=true"
import script from "./ColumnTefError.vue?vue&type=script&lang=js"
export * from "./ColumnTefError.vue?vue&type=script&lang=js"
import style0 from "./ColumnTefError.vue?vue&type=style&index=0&id=3ecb750f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb750f",
  null
  
)

export default component.exports